<div class="webarchive">
  <div class="webarchive__title">
    {{ "Malfunction.ActivityOverTime" | translate }}
    <span>{{ filterSubscriptionName() }}</span>
  </div>
  <div class="webarchive__card">
    @if (loading()) {
      <div class="webarchive__placeholder"></div>
    } @else {
      <div class="webarchive__items">
        @for (item of webarchiveData | keyvalue; track $index) {
          <div
            class="webarchive__item"
            (click)="toggleCalendar(item.key)"
            [class.active]="item.key === activeYear()"
            [class.zero]="ticketsAreZero(item.key, item.value.get('tickets'))"
          >
            <div class="webarchive__chart-box">
              <div class="webarchive__chart">
                @for (amount of item.value.get("tickets"); track $index) {
                  <span [style.animation-delay.ms]="amount * 100">
                    <i [style.height.%]="amount * 10" [class.red]="amount > 10"></i>
                  </span>
                }
              </div>
            </div>
            <div class="webarchive__chart-title">
              <span>{{ item.key }}</span>
              <svg-icon class="webarchive__chart-arrow" src="assets/images/icons/chevron-down.svg"> </svg-icon>
            </div>
          </div>
        }
      </div>
    }
    @if (activeYear(); as year) {
      <div class="webarchive__expand">
        <webarchive-calendar [year]="year" [webarchiveData]="webarchiveData"></webarchive-calendar>
      </div>
    }
  </div>
</div>
